import React, { useEffect, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Form, Button } from 'reactstrap';
import { CommonLabel } from './CommonLabel';
import { CommonSelectInput } from './CommonSelectInput';
import { GET_EMPLOYEES_LIST, GET_LEAD_STATUS_API } from '../../helpers/url_helper';
import { api } from '../../config';
import { fetchLeadStatusRequest } from '../../store/FetchLeadStatus/action';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEmployeesRequest } from '../../store/FetchEmployees/action';

export const CommanSelectModal = ({ getFieldProps, handleSubmit, handleAllStatusChange, allStatusError, assignedError,
    handleAssignedChange, isModalOpen, className, buttonText, headerLabel, toggle }) => {
    const dispatch = useDispatch();
    const { statusOptions } = useSelector(state => state.leadStatusReducer);
    const { employees } = useSelector(state => state.fetchEmployeeReducer);


    useEffect(() => {
        dispatch(fetchEmployeesRequest());
    }, [dispatch]);


    useEffect(() => {
        dispatch(fetchLeadStatusRequest());
    }, [dispatch]);





    return (
        <React.Fragment>
            <Row>
                <Modal isOpen={isModalOpen} toggle={toggle}>
                    <ModalHeader className="bg-light p-3" toggle={toggle}>{headerLabel}</ModalHeader>
                    <Form onSubmit={handleSubmit} className="needs-validation" action="#">
                        <ModalBody>
                            <Row>
                                <Col sm={12}>
                                    <CommonLabel htmlFor="leadstatus">
                                        Select Status
                                    </CommonLabel>

                                    <CommonSelectInput
                                        name="leadstatus"
                                        label="Select Status"
                                        isRequired={true}
                                        value={getFieldProps("leadstatus").value}
                                        onChange={handleAllStatusChange}
                                        onBlur={getFieldProps("leadstatus").onBlur}
                                        options={statusOptions}
                                        tooltipId="my-tooltip-5"
                                    />

                                    {allStatusError && (
                                        <small
                                            className="sales-ninja-select-maltipale-lable"
                                            style={{
                                                color: "red",
                                                position: "absolute",
                                                // bottom: "2px",
                                                left: "22px",
                                            }}
                                        >
                                            <span></span>
                                            {allStatusError}
                                        </small>
                                    )}
                                </Col>
                                {/* Assigned to */}
                                <Col sm={12} className='mt-3'>
                                    <CommonLabel htmlFor="assigned">
                                        Assigned
                                    </CommonLabel>

                                    {/* Assigned Select */}
                                    <CommonSelectInput
                                        name="assigned"
                                        label="Assigned"
                                        isRequired={true}
                                        value={getFieldProps("assigned").value || ""}
                                        onChange={handleAssignedChange}
                                        onBlur={getFieldProps("assigned").onBlur}
                                        options={[
                                            ...employees.map((assigned) => ({
                                                value: assigned?._id,
                                                label: assigned?.fullName,
                                            })),
                                        ]}
                                        tooltipId="my-tooltip-5"
                                    />
                                    {assignedError && (
                                        <small
                                            className="sales-ninja-select-maltipale-lable"
                                            style={{
                                                color: "red",
                                                position: "absolute",
                                                // bottom: "2px",
                                                left: "22px",
                                            }}
                                        >
                                            <span></span>
                                            {assignedError}
                                        </small>
                                    )}
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <div className="hstack gap-2 justify-content-end">
                                <Button type="submit" className={`btn ${className}`}>{buttonText}</Button>
                            </div>
                        </ModalFooter>
                    </Form>
                </Modal>
            </Row>
        </React.Fragment>
    )
}